<template>
    <v-overlay 
        :value="value" 
        absolute>
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
</template>

<script>
export default 
{
   name: 'ActionProviderLoading',

   mixins: [],

   components: 
   {

   },

   data: () => ({

   }),

   props: {
    value: {
        type: Boolean,
        default: false
    }
   },

   computed: 
   {

   },

   methods:
   {
    
   },

   watch:
   {
    
   },

   mounted()
   {

   }
}
</script>